// src/Routes.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WompiInterface from './App';
import ConfirmationPage from './pages/ConfirmationPage';

const AppRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<WompiInterface />} />
                <Route path="/confirmation" element={<ConfirmationPage />} />
            </Routes>
        </Router>
    );
};

export default AppRoutes;
